import handleComplete from 'generic/utils/apiUtils';
import { get } from 'generic/api/apiGenerator';

const getForm = ({ ...rest }) => get({ path: '/formulaire', ...rest }).then(handleComplete);

export {
  // eslint-disable-next-line import/prefer-default-export
  getForm,
};
